<template>
    <div style="padding: 0px;">
        <form>
            <input type="file" @change="onFileChange">
<!--            <input type="submit" value="open" >-->
        </form>
        <div style="margin-top: 10px;">
        <Widget bodyClass="widget-table-overflow" v-if="loaded" style="margin-bottom: 12px;">
            <b-row>
                <b-col>
                            <p style="margin-left: 5%; margin-top: 2%;"><code> Doctors List From Uploaded File </code> </p>
                </b-col>
                <b-col>
                    <div style="margin-left: 50%; margin-bottom: 5%;">
                        <b-button pill variant="outline-success">Create</b-button>
                    </div>
                </b-col>
            </b-row>
            <div class="table-responsive"  style="padding: 0px; height: 60vh; overflow-y: auto;" >
                <table class="table table-lg mb-0 requests-table table-hover" >
                    <thead class="header">
                    <tr>
                      <th v-for="header in headers" v-bind:key="header">{{header}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="per in persons" :key="per.data1">
                        <td v-for="characteristics in per" :key="characteristics">{{characteristics}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Widget>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CsvXlReader",
        data() {
            return {
                fileinput: '',
                rows:[],
                dataseperator:[],
                headers:[],
                persons:[],
                personcount: 0,
                loaded: false,
                numberOfColumn: 0
            };
        },
        methods:{
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createInput(files[0]);
            },
            createInput(file) {
                var reader = new FileReader();
                var vm = this;
                reader.onload = () => {
                    vm.fileinput = reader.result;
                    this.parseFileDataCheck();
                }
                reader.readAsText(file);
            },
            parseFileDataCheck(){
                console.log("it is here");
                if(this.fileinput===''){
                    alert("Please enter a file")
                }else{
                    //console.log(this.fileinput);
                    this.rows=this.fileinput.split('\n');
                    this.getHeaders();
                   // console.log(this.rows);
                    this.makeDataObject();
                }
            },
            getHeaders(){
                this.dataseperator=this.rows[0].split(',');
                this.numberOfColumn=this.dataseperator.length;
                for(var i=0;i<this.numberOfColumn;i++){
                  this.headers[i]=this.dataseperator[i];
                }
            },
            makeDataObject(){
                for(var i=1;i<this.rows.length-1;i++){
                    this.createObject(this.rows[i]);
                }
                this.loaded=true;
            },
            createObject(data){
                console.log(data);
                this.dataseperator= null;
                this.dataseperator=data.split(',');
               // console.log(this.dataseperator);
                let tempPerson={};
                for(var i=0;i<this.numberOfColumn;i++){
                  tempPerson[`${this.headers[i]}`]=this.dataseperator[i];
                }

                console.log(tempPerson);
                this.persons.push(tempPerson);
                //console.log("printing "+this.persons[this.personcount].data1+" "+this.persons[this.personcount].data2);
                this.personcount++;
            }

        },


    };
</script>

<style scoped>
     .header{
           background-color: #f1f1f1;
     }
</style>